import Component from 'flarum/common/Component';
import avatar from 'flarum/common/helpers/avatar';

import UserManageUserEditModal from './modal/UserManageUserEditModal';
import getStatusSetting from '../common/util/getStatusSetting';

export default class UserManageUserListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const {targetData} = this.attrs;
    this.u2diUserType9 = app.forum.attribute('u2diUserType9');
    this.userInfoData = targetData;
  }

  view() {
    const userInfoData = this.userInfoData;
    const userKey = userInfoData.userKey();
    const userData = this.userInfoData.u2diUserData();
    const userCode = this.userInfoData.userCode();
    let expireDays = this.userInfoData.expireDays();
    const noExpiration = this.userInfoData.noExpiration();
    const userType = this.userInfoData.userType();
    const userStatus = this.userInfoData.userStatus();
    const userSuffix = this.userInfoData.userSuffix();
    const userRealName = this.userInfoData.zsxm();
    const userPhone = this.isJson(this.userInfoData.lxdh())===false?this.userInfoData.lxdh():CryptoJSAesJson.decrypt(this.userInfoData.lxdh(), userKey);
    const infoCount = this.userInfoData.infoCount();
    const userSigned = this.userInfoData.userSigned();

    if(userStatus===2){
      expireDays = 0;
    }

    const expireDaysText = noExpiration===1 && userStatus!==2?app.translator.trans('ziven-u2di.forum.item-duration-unlimit'):app.translator.trans('ziven-u2di.forum.item-duration-left',{expireDays:expireDays});
    const userTypeText = app.translator.trans('ziven-u2di.forum.user-type-'+userType);

    const statusSetting = getStatusSetting(userStatus);
    const userStatusText = app.translator.trans('ziven-u2di.forum.user-status-'+userStatus);
    const userStatusColor = statusSetting.statusColor;
    const userStatusStyle = statusSetting.statusStyle;
    const userEditFrom = "admin";

    return (
      <div className="u2diInfoItemContainer">
        <div className="u2diMapSideBarInfoData">
          {this.u2diUserType9===true && (
            <div style="padding: 10px 5px;">
              <div className="u2diUserManagementAvatar">
                <div style="padding: 0px 12px 0px 0px;">{avatar(userData)}</div>
                <div className="u2diUserManagementColumn1">
                  <div style="width: 140px;">
                    <span style={userSigned===1?"color:#A17EFF":""}>{userRealName}</span>
                    {userSuffix && (
                      <span style="font-size:12px;color:gray">&nbsp;({userSuffix})</span>
                    )}
                    {infoCount>0 && (
                      <span style="font-size:12px;color:gray">&nbsp;({infoCount}条)</span>
                    )}
                  </div>
                  <div style="white-space: nowrap;" className="u2diUserManagementColumnItem">{userPhone}</div>
                </div>
                <div className="u2diUserManagementColumn2">
                  <div className="u2diUserManagementColumnItem">{expireDaysText}</div>
                  <div>
                    <div className="u2diUserManagementColumnRoundedItem">{userTypeText}</div>
                    <div style={userStatusStyle} className="u2diUserManagementColumnRoundedItem">{userStatusText}</div>
                    <div className="u2diUserManagementColumnEdit" onclick={(e) => app.modal.show(UserManageUserEditModal,{userInfoData,userEditFrom})}><i class="fas fa-eye"></i></div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }
}